import create from "zustand";

const AuthStore = create((set) => ({
  isAuth: false,
  setIsAuth: (status) => set((state) => ({ isAuth: status })),
}));

export default AuthStore;
